export default __webpack_public_path__ + "static/media/arrow_metrics-enable.00f5fb91.svg";